export enum RiskLevelTypes {
    Low = 0,
    Moderate = 1,
    ModerateHigh = 2,
    High = 3,
    ExtraHigh = 4,
}
